export default {
  PREPARED: 'PREPARED',
  PENDING: 'pending',
  INITED: 'inited',
  LOADED: 'loaded',
  ERROR: 'error',
};
